import { render } from "./ClassReport.vue?vue&type=template&id=dc1830ea&scoped=true"
import script from "./ClassReport.vue?vue&type=script&lang=js"
export * from "./ClassReport.vue?vue&type=script&lang=js"

import "./ClassReport.vue?vue&type=style&index=0&id=dc1830ea&scoped=true&lang=css"

import exportComponent from "/var/www/html/youthmanna/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc1830ea"]])

export default __exports__